import React from 'react'

const ChartsSkeleton = () => (
  <div
    className={
      'shadow-old-design bg-background-secondary flex w-full flex-col gap-9 rounded-lg p-[24px] md:w-[calc(50%-10px)] lg:w-full xl:w-[calc(50%-10px)]'
    }
  >
    <div className={'flex animate-pulse justify-between'}>
      <div className={'flex flex-col gap-1'}>
        <div className={'bg-skeleton-primary h-[16px] w-[70px] rounded-md text-transparent'}>.</div>
        <div className={' bg-skeleton-primary w-[120px] rounded-md py-2 text-transparent'}>.</div>
      </div>
      <div className={`bg-skeleton-primary rounded-md px-11 text-transparent`}>.</div>
    </div>
    <div className={`bg-skeleton-primary animate-pulse rounded-md py-[90px] text-transparent`}>
      .
    </div>
  </div>
)

export default ChartsSkeleton
